import type * as React from 'react'
import { useState } from 'react'

import { Input } from 'Components/_theme'

import { OrderSummaryQuantityInputProps } from './OrderSummary.types'

export const OrderSummaryQuantityInput = (
  props: OrderSummaryQuantityInputProps,
) => {
  const { controlId, defaultValue, onChangeInput } = props
  const [quantity, setQuantity] = useState(defaultValue)

  const handleChangeQuantity = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { target } = event
    const value = Number(target.value)

    if (value < 1) {
      return
    }

    if (target.value.length > 2) {
      const trimedValue = Number(target.value.slice(0, 2))

      setQuantity(trimedValue)
      onChangeInput(trimedValue)
    } else {
      setQuantity(value)
      onChangeInput(value)
    }
  }

  return (
    <Input
      aria-label={controlId}
      className="px-0 text-center w-50"
      id={controlId}
      min={1}
      onChange={handleChangeQuantity}
      required
      step={1}
      type="number"
      value={quantity}
    />
  )
}
